export enum GENERAL_CONSULTATION_STATES {
  PURCHASE_MORE = 'Purchase More',
  PURCHASE_PENDING = 'Purchase Pending',
  SCHEDULE_SESSION = 'Schedule Session',
  UPCOMING = 'Upcoming',
  MISSED = 'Missed',
  JOIN_SESSION = 'Join Session',
  COMPLETED = 'Completed',
  RECONSULT = 'Reconsult',
  CANCELLED = 'Cancelled',
}

export enum LEAD_TO_CALL_STATES {
  STARTED = 'started',
  ASSESSMENT_INITIATED = 'assessmentInitiated',
  ASSESSMENT_COMPLETED = 'assessmentCompleted',
  CHATBOT_BOOKING_INITIATED = 'chatbotBookingInitiated',
  BOOKING_INITIATED = 'bookingInitiated',
  BOOKING_ATTEMPTED = 'bookingAttempted',
  BOOKING_FAILED = 'bookingFailed',
  BOOKING_COMPLETED = 'bookingCompleted',
}
